import DecreasingBanner from './DecreasingBanner';

export default DecreasingBanner;
